import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { RavenService, type TrackEventPayload } from '../services/raven-service/raven-service';

/**
 * 使用埋点（基础函数）
 *
 * **注意**: 不应该直接在业务模块中使用。每个业务模块需要定义自己的 `useXXXXTrack` 函数。
 *
 * @example
 * ```typescript
 * // 在具体模块中封装使用
 * export function useNoveltyCheckTrack() {
 *     const { rvTrack: track } = useRaven();
 *     const route = useRoute();
 *
 *     function rvTrack(eventCode: string, data: Partial<TrackEventPayload> = {}) {
 *         return track(eventCode, {
 *             eventType: TRACK_EVENT_TYPE.NoveltySearch,  // 指定模块的 eventType
 *             otherParam: route.query.taskId as string,
 *             ...data,
 *         });
 *     }
 *     return { rvTrack };
 * }
 * ```
 * @returns
 */
export function useRaven() {
    const ravenService = injectService<RavenService>(RavenService);

    function rvTrack(eventCode: string, data: Partial<TrackEventPayload>) {
        ravenService.track(eventCode, data);
    }

    return {
        /**
         * 跟踪事件
         * @param eventCode 事件名称
         * @param data 其他参数
         */
        rvTrack,
    };
}
